import {computed, Injectable, signal} from '@angular/core';
import { TabItemComponent } from './tab-item/tab-item.component';

@Injectable()
export class TabsService {

  private readonly selectedItem = signal<TabItemComponent | null>(null);

  private readonly allTabs = signal<TabItemComponent[]>([]);

  public readonly selectedTab = this.selectedItem.asReadonly();

  public readonly selectedIndex = computed(() => {
    const selectedItem = this.selectedTab();
    return selectedItem ? this.allTabs().indexOf(selectedItem) : -1;
  });
  public readonly isFirst = computed(() => this.selectedIndex() === 0);
  public readonly isLast = computed(() => this.selectedIndex() === this.allTabs().length - 1);

  constructor() { }

  public isSelected(tab: TabItemComponent): boolean {
    return this.selectedTab() === tab;
  }

  public select(tab: TabItemComponent | null): void {
    this.selectedItem.set(tab);
  }

  public deselect(tab: TabItemComponent | null): void {
    if (this.selectedTab() === tab)
    this.selectedItem.set(null);
  }

  public selectPrevious(): void {
    const selectedIndex = this.selectedIndex();
    if (selectedIndex > 0) {
      const allTabs = this.allTabs();
      this.select(allTabs[selectedIndex - 1]);
    }
  }

  public selectNext(): void {
    const selectedIndex = this.selectedIndex();
    const allTabs = this.allTabs();
    if (selectedIndex < allTabs.length - 1) {
      this.select(allTabs[selectedIndex + 1]);
    }
  }

  public setSelected(tab: TabItemComponent, select: boolean): void {
    if (select) {
      this.select(tab);
    } else {
      this.deselect(tab);
    }
  }

  public selectIndex(index: number): void {
    const allTabs = this.allTabs();
    const indexToSelect = index >= 0 && index < allTabs.length ? index : 0;
    this.select(allTabs[indexToSelect]);
  }

  public toggle(tab: TabItemComponent): void {
    this.select(this.isSelected(tab) ? null : tab);
  }

  public registerTab(tab: TabItemComponent): void {
    this.allTabs.update(tabs => [...tabs, tab]);
  }

  public unregisterTab(tab: TabItemComponent): void {
    this.allTabs.update(tabs => tabs.filter(t => t !== tab));
  }
}
